const environments = {
  local: {
    API_URL: "https://app.akira.ai",
  },
  development: {
    API_URL: "https://app.akira.ai",
  },
  uat: {
    API_URL: "https://app.akira.ai",
  },
  production: {
    API_URL: "https://app.akira.ai",
  },
};

const getEnvironmentConfig = () => {
  const env = process.env.REACT_APP_ENV || "local";

  if (!environments[env]) {
    console.warn(`Environment ${env} not found, falling back to 'local'`);
    return environments.local.API_URL;
  }

  console.log(`Environment: ${env}`);
  console.log("API URL:", environments[env].API_URL);

  return environments[env].API_URL;
};

const API_URL = getEnvironmentConfig();
export default API_URL;
